export default "__VITE_ASSET__e0e59bdb__"